export enum StickyNoteInputMode {
  Create,
  Update,
  Delete
}
